/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

interface Option {
  name: string;
  value: number;
}

interface Threshold extends Option {
  color: string;
}

interface CommonProps {
  id: number;
  slug: string;
  title: string;
  editUrl: string;
  deleteUrl: string;
}

export interface Factor extends CommonProps {
  weight: number;
  options: Option[];
}

export interface Vector extends CommonProps {
  formula: string;
  thresholds: Threshold[];
}

export interface Score extends CommonProps {
  formula: string;
  thresholds: Threshold[];
  heatmapX: string;
  heatmapY: string;
}

export interface TaskTemplate {
  id: number;
  title: string;
  description: string;
  actionTrigger: string;
  assignees: number[];
  reviewers: number[];
  verifiers: number[];
  content: string;
  startDelta: number;
  endDelta: number;
  active: boolean;
}

export interface taskErrorType {
  templateId: number;
  error: string;
}

export enum RiskAddEditMode {
  Add,
  Duplicate,
  Edit,
}

export interface Framework {
  id: number;
  title: string;
  disabled: boolean;
}

export interface CalculationMethod {
  id: number;
  title: string;
  description: string;
  url: string;
}
